import { defer, type LoaderFunctionArgs } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getFreezeDetail } from "./common/service";

export function freezeDetailsLoader({ request }: LoaderFunctionArgs) {
  const accountId = new URL(request.url).searchParams.get("accountId") || "";
  return defer({
    coreData: resolveLoaderResult(getFreezeDetail({ accountId })),
  });
}
